/*
 * Make Range Array
 - - - - - - - - - -
 Returns an array holding a specific range of numbers, with an optional start
 */
export const makeRangeArray = (range: number, start = 0) => {
  return [...Array(range).keys()].map((i) => i + start);
};
